var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRightcolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ArrowUpRight"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 24L24 8",
    stroke: "url(#paint0_linear_554_288)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 8H24V21",
    stroke: "url(#paint1_linear_554_288)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_288",
    x1: 24,
    y1: 14.8,
    x2: 8,
    y2: 14.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_554_288",
    x1: 24,
    y1: 13.525,
    x2: 11,
    y2: 13.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRightcolor);
export default __webpack_public_path__ + "static/media/ArrowUpRightcolor.7f4ca7ca0ab5c7aaa5bb615b85ba6fa8.svg";
export { ForwardRef as ReactComponent };